import { Component, ElementRef, Input, Optional, Renderer2, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import * as _ from 'lodash';

@Component({
    selector: 'gl-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    standalone: false
})
export class SliderComponent implements ControlValueAccessor {
  @ViewChild('input', { static: true }) input: ElementRef;
  @ViewChild('label', { static: true }) label: ElementRef;
  @Input() unit: string;
  @Input() min: number;
  @Input() max: number;
  @Input() isDisabled = false;
  public value: number;

  constructor(
    @Optional()
    @Self()
    public controlDir: NgControl,
    private renderer: Renderer2,
  ) {
    if (controlDir) {
      controlDir.valueAccessor = this;
    }
  }
public formatValue(value: number): string {
  if (value === 0) {
    return '0';
  }
  return value.toFixed(2).replace(/\.?0+$/, '');
}
  public writeValue(value: number): void {
    this.value = value;
    this.renderer.setProperty(this.input.nativeElement, 'value', value);
    setTimeout(() => this.setLabelLeftPercentage(this.value));
  }

  public registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public change(event) {
    this.value = event.target.value as number;
    this.propagateChange(event.target.value);
  }

  public mouseMove(event) {
    this.value = event.target.value as number;
    this.setLabelLeftPercentage(this.value);
  }

  public setLabelLeftPercentage(value: number) {
    this.value = value;
    const tmpValue = this.value >= 0 && this.value <= 100 ? this.value : 50;
    let left = tmpValue + '%';

    if (_.isNumber(+this.min) && _.isNumber(+this.max)) {
      left = ((this.value - this.min) * 100) / (this.max - this.min) + '%';
    }

    this.label.nativeElement.style.left = left;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.renderer.setProperty(this.input.nativeElement, 'disabled', isDisabled);
  }

  private propagateChange = (_: any) => undefined;
  onTouched = () => undefined;
}
